const TemplateItem = ({
  name,
  videoUrl,
  selected = false,
  onClick,
  className = "",
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`group p-1 md:p-2 lg:p-3 relative w-full rounded-md shadow-md card overflow-hidden transition duration-300 focus:outline-none  ${
        selected
          ? "border-empower-500 border-2 border-solid"
          : "hover:border-empower-500 border-2 border-transparent"
      } ${className}`}
    >
      <div className="pb-1 flex items-center justify-between">
        <div className="font-semibold truncate">{name}</div>
      </div>
      <div className="bg-empower-200 group-hover:bg-empower-500 transition-colors duration-300">
        {videoUrl ? (
          <video
            src={videoUrl}
            className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity duration-300"
            muted
            loop
            autoPlay
            // Set playbackRate to 2x speed when video is ready
            onCanPlay={(e) => {
              e.currentTarget.playbackRate = 2;
            }}
          />
        ) : null}
      </div>
    </button>
  );
};

export default TemplateItem;
